export enum EKeysAllowedType {
  Decimals = 'decimals',
}
